import React from 'react';
import styled from 'styled-components';
import { animated } from '@react-spring/web';
import History from 'components/History/History';
import ContextMenu from './ContextMenu';
import { useSpring } from 'react-spring';
import RtlStyles from 'i18n/rtl';
import { usePlannerConfig } from 'contexts/plannerConfig';

const Wrapper = styled(animated.div)`
  display: flex;
  position: absolute;
  transition: transform 0.1s ease-out;
  width: 100%;
  padding: 0 1rem;
  padding-bottom: ${({ theme }) => theme.space.xs};
  justify-content: space-between;
  align-items: center;
  pointer-events: none;

  > div {
    pointer-events: auto;
  }
`;

const ActionButtonsWrapper = styled.ul`
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: ${({ theme }) => theme.space.xs};
  padding: 0;
  margin: 0;
  list-style: none;

  > li {
    margin-right: 1rem;
  }

  > li:nth-child(3) {
    margin-right: 0;
  }
`;

const AnimationWrapper = styled(animated.li)`
  transition: transform 0.1s ease-out;
`;

type Props = {
  animationProps: any;
  bottomOffset: number;
  selected: boolean;
};

const SceneMenu = ({ animationProps, bottomOffset, selected }: Props) => {
  const animation = useSpring({
    opacity: selected ? 0 : 1,
    zIndex: selected ? 0 : 1
  });

  const ActionButtons = () => {
    const { plannerConfig } = usePlannerConfig();

    return (
      <RtlStyles>
        <ActionButtonsWrapper>
          {plannerConfig.sceneActions.map(SceneAction => {
            return (
              <AnimationWrapper
                style={{
                  opacity: animation.opacity,
                  zIndex: animation.zIndex
                }}
                key={SceneAction.name}
              >
                <SceneAction />
              </AnimationWrapper>
            );
          })}
        </ActionButtonsWrapper>
      </RtlStyles>
    );
  };

  return (
    <Wrapper
      style={{
        transform: animationProps?.position.to((position: number) => `translateY(-${position}px)`),
        bottom: `${bottomOffset}px`
      }}
    >
      <div>
        <ActionButtons />
        <ContextMenu />
      </div>
      <History />
    </Wrapper>
  );
};

export default SceneMenu;
